import {useQuery} from "react-query";

import {http} from "../../../services/api/restApiClient";
import {CommitWithResults} from "../types";

export const useContentCommits = () => {
  return useQuery(
    ["content_commits"],
    async () => {
      const {data} = await http.get<{commits: CommitWithResults[]}>(
        "/template-commits",
      );
      return data.commits;
    },
    {
      refetchOnMount: true,
      refetchInterval: 30000,
    },
  );
};
